import React, { forwardRef, Component } from 'react';
import PropTypes from 'prop-types';
import { Modal as MainModal } from 'reactstrap';

import './Modal.scss';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isOpen': props.show,
    };
  }

  componentDidMount() {
    if (this.props.show && !document.querySelector('body').className.includes('modal-open')) { // fix bug lib not add class
      document.querySelector('body').className = 'modal-open';
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      return this.setState({ 'isOpen': nextProps.show });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isOpen !== this.state.isOpen && this.state.isOpen) {
      if (!document.querySelector('body').className.includes('modal-open')) { // fix bug lib not add class
        document.querySelector('body').className = 'modal-open';
      }
    }
  }

  componentWillUnmount() {
    this.handleRemoveClass();
  }

  handleRemoveClass = () => {
    try {
      const { disableRemoveClass } = this.props;

      if (document.querySelectorAll('.modal').length <= 1 && !disableRemoveClass) { // fix bug lib not remove class
        document.querySelector('body').className = document.querySelector('body').className.replace(' ', ',').replace('modal-open', '').replace(',', ' ').trim();
      }
    } catch (error) {
      return null;
    }
  }

  handleToggle = () => {
    try {
      const { handleToggle } = this.props;

      this.setState({ 'isOpen': !this.setState.isOpen });

      this.handleRemoveClass();
      return handleToggle();
    } catch (error) {
      return null;
    }
  };

  render() {
    const { isOpen } = this.state;
    const { innerRef, header, headerTemplate, iconOther, handleToggle, children, x2 } = this.props;

    return (
      <MainModal
        isOpen={isOpen}
        toggle={this.handleToggle}
        className={`Modal-custom-template${x2 ? ' x2' : ''}`}
        ref={innerRef}
        centered
        backdropClassName="Modal-custom-template-backdrop"
      >
        <div className="box-template">
          {
            header ?
              <div className={`modal-header${headerTemplate ? ` template-${headerTemplate}` : ''}`}>
                <span className="title" id="modal-title">{header}</span>
                <span>
                  {iconOther}
                  <span className="icon fas fa-times" id="btn-close-modal" onClick={handleToggle} />
                </span>
              </div>
              : null
          }
          <div className="modal-body">
            {children}
          </div>
        </div>
      </MainModal>
    );
  }
}

Modal.propTypes = {
  'show': PropTypes.bool.isRequired,
  'handleToggle': PropTypes.func,
  'children': PropTypes.any,
  'header': PropTypes.any,
  'iconOther': PropTypes.any,
  'headerTemplate': PropTypes.string,
  'disableRemoveClass': PropTypes.bool,
  'innerRef': PropTypes.any,
  'x2': PropTypes.bool,
};

const ModalRef = forwardRef((props, ref) => <Modal {...props} innerRef={ref} />);

export default ModalRef;
